import {
  ApiFile,
  AppFile,
  ReasonNote,
  VesselCertificateStatus,
  VesselNoteType,
  VesselStatus,
} from './core';

export const MINIMUM_AMOUNT_OF_VESSELS_PER_OPERATOR = 2;

export type VesselRejectionNote = ReasonNote<VesselNoteType>;

interface BaseVesselCertificate<TFile> {
  id: string;
  classMode: string;
  startDate: string;
  endDate: string;
  minimumCrew: number;
  maximumPassengers: number;
  files: TFile[];
  status: VesselCertificateStatus;
  notes?: VesselRejectionNote[];
  isExpired: boolean;
}

export type VesselCertificate = BaseVesselCertificate<AppFile>;
export type ApiVesselCertificate = BaseVesselCertificate<ApiFile>;

export type NewVesselCertificate = Omit<
  VesselCertificate,
  'id' | 'status' | 'isExpired' | 'notes'
>;

export interface Vessel {
  id: string;
  operatorId: string;
  name: string;
  flag: string;
  regNumber: string;
  yearOfBuild: number;
  lengthOverall: number | null;
  beam: number;
  loadDraft: number | null;
  horsePower: number;
  ratedEngineSpeed: number;
  fuelType: string;
  bunkerCapacity: number | null;
  averageFuelConsumption: number;
  manningScale: string;
  detailsOfConversion: string | null;
  currentSurveyStatus: string | null;
  dryDockingSchedule: string;
  dateOfLastDryDocking: string /* Format YYYY-MM-DD */;
  detailsOfCargoGear: string | null;
  cargoCapacity: string | null;
  vesselOwner: string | null;
  detailsOfDetentions: string | null;
  passengerCarriageCapacity: string | null;
  averageCrossingTime: number;
  status: VesselStatus;
  deleteDate: string | null /* Format: YYYY-MM-DD */;
}

export type NewVessel = Omit<Vessel, 'id' | 'status' | 'deleteDate'>;

export type UpdatedVessel = Omit<
  Vessel,
  'status' | 'operatorId' | 'regNumber' | 'deleteDate'
>;

export interface VesselListItem {
  id: string;
  operatorId: string;
  operatorName: string;
  vesselName: string;
  regNumber: string;
  flag: string;
  validCertificationsCount: number;
  pendingCertificationsCount: number;
  status: VesselStatus;
  expiredSoon: boolean;
  deleteDate: string | null /* Format: YYYY-MM-DD */;
}

export interface VesselContractAssignment {
  contractId: string;
  contractName: string;
  contractStatus: 'Undefined' | 'Active';
  isPrimary: true;
}
